// The page someone was trying to reach when they were sent to sign in.
//
// Kept in a cookie rather than sessionStorage because both halves of the app need
// it: the SPA consumes it after a password sign-in, and the server reads it in the
// Google callback (`routes/auth.js`), which is a server-side redirect and would
// otherwise always land on `/`. The case that matters is the "View or reply" link
// in a notification email — clicking it must end on that ticket, not on the queue.
//
// The validation mirrors lib/return-to.js. The server's copy is the one that
// matters for safety (it turns the value into a real redirect); this one keeps a
// junk cookie from sending the router somewhere meaningless.

const COOKIE = 'return_to'
const MAX_AGE = 600

function isSafe(path) {
  return typeof path === 'string' &&
    path.length <= 512 &&
    path.startsWith('/') &&
    !path.startsWith('//') &&
    !path.startsWith('/\\') &&
    !path.includes('#') &&
    !/[\u0000-\u0020\u007f]/.test(path)
}

function readCookie() {
  const prefix = `${COOKIE}=`
  for (const part of document.cookie.split('; ')) {
    if (part.startsWith(prefix)) {
      try { return decodeURIComponent(part.slice(prefix.length)) } catch { return null }
    }
  }
  return null
}

// `path=/` is not optional: without it the cookie is scoped to the directory of
// whatever page set it (`/tickets/`), and neither `/login` nor the OAuth callback
// would ever see it.
function writeCookie(value, maxAge) {
  const secure = window.location.protocol === 'https:' ? '; secure' : ''
  document.cookie = `${COOKIE}=${value}; path=/; max-age=${maxAge}; samesite=lax${secure}`
}

export function rememberReturnTo(path) {
  if (!isSafe(path) || path === '/') return
  writeCookie(encodeURIComponent(path), MAX_AGE)
}

// Read once and clear — a remembered destination is spent the moment it is used.
export function takeReturnTo() {
  const path = readCookie()
  if (path !== null) writeCookie('', 0)
  return isSafe(path) ? path : null
}
